import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  Badge,
  Form,
  Alert,
  Modal
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class EmployeeFamilyManagement extends Component {
  constructor(props) {
    super(props);
    
    // Get URL parameters for companyid and employeeid
    const urlParams = new URLSearchParams(window.location.search);
    const paramCompanyId = urlParams.get('companyid');
    const paramEmployeeId = urlParams.get('employeeid');
    
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      
      // URL parameters
      companyId: paramCompanyId,
      employeeId: paramEmployeeId,
      
      // Family data
      familyMembers: [],
      employeeInfo: {},
      
      // Loading states
      isLoading: true,
      isSaving: false,
      
      // Modal states
      showAddMemberModal: false,
      showEditMemberModal: false,
      showDeleteConfirm: false,
      
      // Form data
      addMemberForm: {
        memberfullname: "",
        gender: "",
        dob: "",
        relationwithemployee: "",
        suminsured: "",
        pincode: "",
        mobilenumber: "",
        emailId: ""
      },
      editingMember: null,
      deletingMember: null,
      
      // Table columns
      tableColumns: [
        {
          name: "Member Name",
          selector: (row) => row.memberfullname,
          sortable: true,
          width: "180px",
          cell: (row) => <span>{row.memberfullname || 'N/A'}</span>,
        },
        {
          name: "Relationship",
          selector: (row) => row.relationwithemployee,
          sortable: true,
          width: "120px",
          cell: (row) => (
            <Badge bg={row.relationwithemployee === 'Self' ? 'primary' : 'secondary'}>
              {row.relationwithemployee}
            </Badge>
          ),
        },
        {
          name: "Gender",
          selector: (row) => row.gender,
          sortable: true,
          width: "80px",
          cell: (row) => <span>{row.gender || 'N/A'}</span>,
        },
        {
          name: "Date of Birth",
          selector: (row) => row.dob,
          sortable: true,
          width: "120px",
          cell: (row) => <span>{row.dob || 'N/A'}</span>,
        },
        {
          name: "Sum Insured",
          selector: (row) => row.suminsured,
          sortable: true,
          width: "120px",
          cell: (row) => <span>{row.suminsured || 'N/A'}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          width: "200px",
          cell: (row) => (
            <div>
              <Button
                variant="warning"
                size="sm"
                onClick={() => this.handleEditMember(row)}
                className="me-1"
                title="Edit Member"
              >
                <i className="bi bi-pen"></i>
              </Button>
              {row.relationwithemployee !== 'Self' && (
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => this.handleDeleteMember(row)}
                  className="me-1"
                  title="Delete Member"
                >
                  <i className="bi bi-trash"></i>
                </Button>
              )}
              <Button
                variant="success"
                size="sm"
                onClick={() => this.handleManagePED(row)}
                className="me-1"
                title="Manage PED"
              >
                <i className="bi bi-heart-pulse"></i>
              </Button>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    if (this.state.companyId && this.state.employeeId) {
      this.loadEmployeeInfo();
      this.loadFamilyMembers();
    } else {
      this.showToast("Company ID and Employee ID are required", "error");
      this.setState({ isLoading: false });
    }
  }

  showToast = (message, type) => {
    toast(message, { type: type });
  };

  // Load employee information
  loadEmployeeInfo = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyId", this.state.companyId);
    formData.append("employeeId", this.state.employeeId);

    fetch(configData.api_url + "C_Healthmemberdata/get_employee_info", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employeeInfo: data.employeeInfo });
        }
      })
      .catch((error) => {
        this.showToast("Error loading employee information", "error");
      });
  };

  // Load family members
  loadFamilyMembers = () => {
    this.setState({ isLoading: true });
    
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyId", this.state.companyId);
    formData.append("employeeId", this.state.employeeId);

    fetch(configData.api_url + "C_Healthmemberdata/get_family_members_detailed", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ 
            familyMembers: data.members || [],
            isLoading: false 
          });
        } else {
          this.showToast(data.message, "error");
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        this.showToast("Error loading family members", "error");
        this.setState({ isLoading: false });
      });
  };

  // Handle add member form change
  handleAddMemberFormChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      addMemberForm: {
        ...prevState.addMemberForm,
        [name]: value
      }
    }));
  };

  // Add new family member
  addNewMember = () => {
    const { addMemberForm } = this.state;

    // Validate required fields
    if (!addMemberForm.memberfullname || !addMemberForm.gender || 
        !addMemberForm.dob || !addMemberForm.relationwithemployee) {
      this.showToast("Please fill all required fields", "error");
      return;
    }

    this.setState({ isSaving: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", this.state.companyId);
    formData.append("employeeid", this.state.employeeId);
    
    Object.keys(addMemberForm).forEach(key => {
      if (addMemberForm[key]) {
        formData.append(key, addMemberForm[key]);
      }
    });

    fetch(configData.api_url + "C_Healthmemberdata/add_family_member", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          this.setState({
            showAddMemberModal: false,
            isSaving: false,
            addMemberForm: {
              memberfullname: "",
              gender: "",
              dob: "",
              relationwithemployee: "",
              suminsured: "",
              pincode: "",
              mobilenumber: "",
              emailId: ""
            }
          });
          this.loadFamilyMembers();
        } else {
          this.showToast(data.message, "error");
          this.setState({ isSaving: false });
        }
      })
      .catch((error) => {
        this.showToast("Error adding family member", "error");
        this.setState({ isSaving: false });
      });
  };

  // Handle edit member
  handleEditMember = (member) => {
    this.setState({
      editingMember: { ...member },
      showEditMemberModal: true
    });
  };

  // Handle member form change for editing
  handleEditMemberFormChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      editingMember: {
        ...prevState.editingMember,
        [name]: value
      }
    }));
  };

  // Update family member
  updateMember = () => {
    const { editingMember } = this.state;

    if (!editingMember.memberfullname || !editingMember.gender || 
        !editingMember.dob || !editingMember.relationwithemployee) {
      this.showToast("Please fill all required fields", "error");
      return;
    }

    this.setState({ isSaving: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", this.state.companyId);
    formData.append("employeeid", this.state.employeeId);
    formData.append("healthmemberdata_Id", editingMember.healthmemberdata_Id);
    
    // Add all editable fields
    const editableFields = ['memberfullname', 'gender', 'dob', 'relationwithemployee', 
                           'suminsured', 'pincode', 'mobilenumber', 'emailId'];
    editableFields.forEach(field => {
      if (editingMember[field]) {
        formData.append(field, editingMember[field]);
      }
    });

    fetch(configData.api_url + "C_Healthmemberdata/update_family_member", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          this.setState({
            showEditMemberModal: false,
            editingMember: null,
            isSaving: false
          });
          this.loadFamilyMembers();
        } else {
          this.showToast(data.message, "error");
          this.setState({ isSaving: false });
        }
      })
      .catch((error) => {
        this.showToast("Error updating family member", "error");
        this.setState({ isSaving: false });
      });
  };

  // Handle delete member
  handleDeleteMember = (member) => {
    this.setState({
      deletingMember: member,
      showDeleteConfirm: true
    });
  };

  // Confirm delete member
  confirmDeleteMember = () => {
    const { deletingMember } = this.state;

    this.setState({ isSaving: true });

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("healthmemberdata_Id", deletingMember.healthmemberdata_Id);

    fetch(configData.api_url + "C_Healthmemberdata/delete_family_member", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          this.setState({
            showDeleteConfirm: false,
            deletingMember: null,
            isSaving: false
          });
          this.loadFamilyMembers();
        } else {
          this.showToast(data.message, "error");
          this.setState({ isSaving: false });
        }
      })
      .catch((error) => {
        this.showToast("Error deleting family member", "error");
        this.setState({ isSaving: false });
      });
  };

  // Handle manage PED navigation
  handleManagePED = (member) => {
    if (!member.healthmemberdata_Id) {
      this.showToast("Member ID is missing", "error");
      return;
    }
    
    // Navigate to PED_Magma with URL parameters including member ID
    const pedUrl = `/pedmagma?companyid=${this.state.companyId}&employeeid=${this.state.employeeId}&memberid=${member.healthmemberdata_Id}`;
    
    this.showToast(`Navigating to PED Management for ${member.memberfullname}`, "info");
    
    setTimeout(() => {
      window.location.href = pedUrl;
    }, 1000);
  };

  render() {
    const { familyMembers, isLoading, addMemberForm, editingMember, deletingMember, isSaving } = this.state;

    if (isLoading) {
      return (
        <Container fluid className="mt-3">
          <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3">
                <h5>Loading family members...</h5>
              </div>
            </div>
          </div>
        </Container>
      );
    }

    return (
      <Container fluid className="mt-3">
        <h3 className="logoskybluecolor mb-4">Employee Family Management</h3>
        
        {/* Header Information */}
        <Row className="mb-4">
          <Col lg={12}>
            <Alert variant="info">
              <i className="bi bi-info-circle me-2"></i>
              <strong>Managing family for:</strong> Employee ID: {this.state.employeeId} | Company ID: {this.state.companyId}
              <br />
              <small>Add, edit, or remove family members. Use the PED button to manage Pre-Existing Diseases for each member.</small>
            </Alert>
          </Col>
        </Row>

        {/* Action Buttons */}
        <Row className="mb-3">
          <Col lg={6}>
            <Button 
              variant="primary" 
              onClick={() => this.setState({ showAddMemberModal: true })}
              className="me-2"
            >
              <i className="bi bi-plus-circle me-2"></i>
              Add Family Member
            </Button>
            <Button 
              variant="secondary" 
              onClick={() => window.history.back()}
            >
              <i className="bi bi-arrow-left me-2"></i>
              Back to Employees
            </Button>
          </Col>
        </Row>

        {/* Family Members Table */}
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Header>
                <h5>Family Members ({familyMembers.length})</h5>
              </Card.Header>
              <Card.Body>
                <DataTable
                  data={familyMembers}
                  columns={this.state.tableColumns}
                  pagination
                  keyField="healthmemberdata_Id"
                  className="table table-striped table-bordered"
                  noDataComponent="No family members found"
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Add Member Modal */}
        <Modal 
          show={this.state.showAddMemberModal} 
          onHide={() => this.setState({ showAddMemberModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Family Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Member Full Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="memberfullname"
                      value={addMemberForm.memberfullname}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Full Name"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Relationship *</Form.Label>
                    <Form.Select
                      name="relationwithemployee"
                      value={addMemberForm.relationwithemployee}
                      onChange={this.handleAddMemberFormChange}
                      required
                    >
                      <option value="">Select Relationship</option>
                      <option value="Spouse">Spouse</option>
                      <option value="Son">Son</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Mother">Mother</option>
                      <option value="Father">Father</option>
                      <option value="Motherinlaw">Mother-in-law</option>
                      <option value="Fatherinlaw">Father-in-law</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gender *</Form.Label>
                    <Form.Select
                      name="gender"
                      value={addMemberForm.gender}
                      onChange={this.handleAddMemberFormChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date of Birth *</Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      value={addMemberForm.dob}
                      onChange={this.handleAddMemberFormChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Sum Insured</Form.Label>
                    <Form.Control
                      type="number"
                      name="suminsured"
                      value={addMemberForm.suminsured}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Sum Insured"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="mobilenumber"
                      value={addMemberForm.mobilenumber}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Mobile Number"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email ID</Form.Label>
                    <Form.Control
                      type="email"
                      name="emailId"
                      value={addMemberForm.emailId}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Email ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showAddMemberModal: false })}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.addNewMember} disabled={isSaving}>
              {isSaving ? 'Adding...' : 'Add Member'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Member Modal */}
        <Modal 
          show={this.state.showEditMemberModal} 
          onHide={() => this.setState({ showEditMemberModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Family Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editingMember && (
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Member Full Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="memberfullname"
                        value={editingMember.memberfullname || ''}
                        onChange={this.handleEditMemberFormChange}
                        placeholder="Enter Full Name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Relationship *</Form.Label>
                      <Form.Select
                        name="relationwithemployee"
                        value={editingMember.relationwithemployee || ''}
                        onChange={this.handleEditMemberFormChange}
                        required
                        disabled={editingMember.relationwithemployee === 'Self'}
                      >
                        <option value="">Select Relationship</option>
                        <option value="Self">Self</option>
                        <option value="Spouse">Spouse</option>
                        <option value="Son">Son</option>
                        <option value="Daughter">Daughter</option>
                        <option value="Mother">Mother</option>
                        <option value="Father">Father</option>
                        <option value="Motherinlaw">Mother-in-law</option>
                        <option value="Fatherinlaw">Father-in-law</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Gender *</Form.Label>
                      <Form.Select
                        name="gender"
                        value={editingMember.gender || ''}
                        onChange={this.handleEditMemberFormChange}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth *</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={editingMember.dob || ''}
                        onChange={this.handleEditMemberFormChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Sum Insured</Form.Label>
                      <Form.Control
                        type="number"
                        name="suminsured"
                        value={editingMember.suminsured || ''}
                        onChange={this.handleEditMemberFormChange}
                        placeholder="Enter Sum Insured"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="tel"
                        name="mobilenumber"
                        value={editingMember.mobilenumber || ''}
                        onChange={this.handleEditMemberFormChange}
                        placeholder="Enter Mobile Number"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email ID</Form.Label>
                      <Form.Control
                        type="email"
                        name="emailId"
                        value={editingMember.emailId || ''}
                        onChange={this.handleEditMemberFormChange}
                        placeholder="Enter Email ID"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showEditMemberModal: false })}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.updateMember} disabled={isSaving}>
              {isSaving ? 'Updating...' : 'Update Member'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteConfirm} onHide={() => this.setState({ showDeleteConfirm: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {deletingMember && (
              <p>
                Are you sure you want to delete <strong>{deletingMember.memberfullname}</strong> from the family?
                <br />
                <small className="text-muted">This action cannot be undone.</small>
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirm: false })}>
              Cancel
            </Button>
            <Button variant="danger" onClick={this.confirmDeleteMember} disabled={isSaving}>
              {isSaving ? 'Deleting...' : 'Delete Member'}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}